import { useQuery } from "@tanstack/react-query";
import cmsClient from "src/services/cmsClient";
import { adaptQuickLinks } from "../adapters/adaptQuickLinks";

const fetchQuickLinks = async (published: boolean) => {
	const response = await cmsClient.get<IQuickLink[]>(
		"/homepage/admin/quicklink/",
		{
			params: { published }
		}
	);

	return response.data;
};

const useQuickLinks = (published: boolean) => {
	const query = useQuery(
		["quick-links", published],
		() => fetchQuickLinks(published),
		{
			select: adaptQuickLinks
		}
	);

	return query;
};

export default useQuickLinks;
